<script setup lang="ts"></script>

<template>
  <icon name="lucide:list-chevrons-up-down" />
</template>

<style scoped></style>
